import React, { useId, useState } from "react";
import "react-phone-number-input/style.css";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import "../../../css/DesignSystem/Inputs/MobileNumberInput.css";

const supportedCountries = [
  "GB",
  "IE",
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IT",
  "LV",
  "LT",
  "LU",
  "MT",
  "NL",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "US",
  "CA",
  "AR",
  "BR",
  "CL",
  "CO",
  "MX",
  "PE",
  "UY",
  "VE",
  "IN",
  "CN",
  "JP",
  "KR",
  "SG",
  "HK",
  "MY",
  "TH",
  "VN",
  "PH",
  "ID",
  "AU",
  "NZ",
  "AE",
  "SA",
  "QA",
  "KW",
  "BH",
  "OM",
  "ZA",
  "NG",
  "KE",
  "EG",
];

const MobileNumberInput = ({
  id,
  label = "",
  placeholder = "Mobile number",
  value,
  onChange,
  isRequired = false,
  disabled = false,
  defaultCountry = "GB",
  error = "",
  helpText = "",
}) => {
  const autoId = useId();
  const inputId = id || `mobile-${autoId}`;
  const [touched, setTouched] = useState(false);
  const [hasFocus, setHasFocus] = useState(false);

  // Convert empty string to undefined so placeholder shows
  const phoneValue = value && value.trim() !== "" ? value : undefined;
  const invalid = touched && phoneValue && !isValidPhoneNumber(phoneValue);

  return (
    <div
      className={`ds-input-field ${invalid || error ? "ds-input-field--error" : ""}`}
    >
      {label && (
        <div htmlFor={inputId} className="Content-Small" aria-live="polite">
          {label}
          {isRequired && <span className="ds-input-required">*</span>}
        </div>
      )}

      <div
        className={`ds-input-wrapper ds-phone-input ${hasFocus ? "is-focused" : ""}`}
        onFocusCapture={() => setHasFocus(true)}
        onBlurCapture={(e) => {
          if (!e.currentTarget.contains(e.relatedTarget)) {
            setHasFocus(false);
            setTouched(true);
          }
        }}
      >
        <PhoneInput
          id={inputId}
          value={phoneValue}
          onChange={(val) => onChange?.(val)}
          placeholder={placeholder}
          defaultCountry={defaultCountry}
          countries={supportedCountries}
          limitMaxLength
          international
          withCountryCallingCode
          countryCallingCodeEditable={false}
          disabled={disabled}
          aria-invalid={Boolean(invalid || error)}
          aria-label={label ? undefined : placeholder}
          className="Content ds-phone-input-control"
          numberInputProps={{
            placeholder: placeholder,
          }}
        />
      </div>

      {/* {(invalid || error || helpText) && (
        <div
          className={`ds-input-helper ${invalid || error ? "ds-input-helper--error" : ""}`}
        >
          {error || (invalid ? "Please enter a valid phone number." : helpText)}
        </div>
      )} */}
    </div>
  );
};

export default MobileNumberInput;
